import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from './AuthContext';

const NavBar = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 20px;
  background-color: #007bff;
  z-index: 1000;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Logo = styled.div`
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-size: 1rem;

  &:hover {
    text-decoration: underline;
  }
`;

const LogoutButton = styled.div`
  color: white;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const NavigationBar: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    logout();
    navigate('/login');
  };

  return (
    <NavBar>
      <Logo>AUNE</Logo>
      <NavLinks>
        {isAuthenticated ? (
          <LogoutButton onClick={handleLogout}>Déconnexion</LogoutButton>
        ) : (
          <><NavLink to="/">Accueil</NavLink>
          <NavLink to="/delete-account">Supprimer mon compte</NavLink></>
        )}
      </NavLinks>
    </NavBar>
  );
};

export default NavigationBar;
